import {
    Directive,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnDestroy,
    OnInit,
    Output
  } from '@angular/core';
  
  @Directive({
    selector: '[ntsObserveVisibility]',
    standalone: true
  })
  export class ObserveVisibilityDirective implements OnInit, OnDestroy {
    @Output() visibleChange = new EventEmitter<boolean>();
  
    @Input() threshold: number = 0.1;
    @Input() root: HTMLElement | null = null;
  
    private observer!: IntersectionObserver;
  
    constructor(private el: ElementRef, private zone: NgZone) {}
  
    ngOnInit(): void {
      this.zone.runOutsideAngular(() => {
        this.observer = new IntersectionObserver(
          ([entry]) => {
            // Entra di nuovo in Angular zone per emettere l'evento
            this.zone.run(() => {
              this.visibleChange.emit(entry.isIntersecting);
            });
          },
          {
            root: this.root,
            threshold: this.threshold
          }
        );
        this.observer.observe(this.el.nativeElement);
      });
    }
  
    ngOnDestroy(): void {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }